import { Document, Image, PDFViewer, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import moment from 'moment'
import React from 'react'
import { useSelector } from 'react-redux'

const GeneratePDF = (props) => {
    const { loginData } = useSelector((state) => state.common)
    const styles = StyleSheet.create({
        page: {
            backgroundColor: '#fff',
            paddingBottom: '80pt',
            paddingHorizontal: '20pt'
        },
        heading: {
            alignItems: "flex-start",
            flexDirection: 'row',
            justifyContent: "space-between",
            alignItems: 'center',
            paddingVertical: 10,
            fontSize: '24px',
            color: "#0086FF",
            fontWeight: 500,
        },
        headingRow: {
            flexDirection: 'row',
            alignItems: 'center'
        },
        image: {
            width: '50px',
            height: '50px'
        },
        subHeading: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingVertical: 10
        },
        footer: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            paddingHorizontal: 20,
            paddingVertical: 10,
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
            borderTop: "1pt solid #A6A8AB",
        }

    })
    return (
        <PDFViewer style={{ width: props.width, height: props.height }}>
            <Document title={props.title}>
                <Page size={props.size} orientation={props?.orientation?props?.orientation:'portrait'} style={styles.page}>
                    {/* header */}
                    <View fixed style={styles.heading}>
                        <View style={styles.headingRow}>
                            <Image src={"/images/logo-66.png"} style={styles.image} />
                            <Text style={{ ...styles.heading, paddingLeft: '10pt' }}>
                                Cargo System | {props.reportName}
                            </Text>
                        </View>
                        <View>
                            <Text style={{ fontWeight: 800, fontSize: '20px', color: '#444' }}>
                                Company Name: {loginData.strCompanyName}
                            </Text>
                        </View>
                    </View>
                    {props.isSubHeading && <View style={styles.subHeading}>
                        <Text style={{ fontWeight: 700, fontSize: '16px', color: '#444' }}>
                            {props.generateDate}
                        </Text>
                        <Text style={{ fontWeight: 700, fontSize: '16px', color: '#444' }}>
                            {props.reportView}
                        </Text>
                    </View>
                    }
                    {props.children}
                    {/* footer */}
                    <View style={styles.footer} fixed>
                        <Text style={{ fontSize: '16px', fontWeight: 700, color: "#444" }}>
                            Report By : {`${loginData.strUserName} [ ${loginData.strBranchName} ]`}
                        </Text>
                        <Text style={{ fontSize: '16px', fontWeight: 700, color: "#444" }}>
                            Report Time : {`${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`}
                        </Text>
                        <Text style={{ fontSize: '16px', fontWeight: 700, color: "#444" }} render={({ pageNumber, totalPages }) =>
                            `Page:${pageNumber} of ${totalPages}`
                        } />
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    )
}

export default GeneratePDF